import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
    background: none;
    border: none;
    color: ${props => props.color || 'black'};
    line-height: 0;
`;

const Svg = styled.svg`
    fill: currentColor;
    stroke: inherit;
`;

export const BurgerButton = ({ toggle, color }) => (
    <Button type="button" onClick={toggle}>
        <Svg
            height="17"
            viewBox="0 0 16 17"
            width="16"
            xmlns="http://www.w3.org/2000/svg"
            color={color}
        >
            <path
                clipRule="evenodd"
                d="m16 2.52816-16-.00304.0002909-1.530003 16.0000091.003043zm0 7.23215-15.9999924-.00304.00029093-1.53 16.00000147.00304zm-15.9999924 7.23259 15.9999924.003.0003-1.53-16.00000147-.003z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </Svg>
    </Button>
);
